import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";


const NotificationsRulesList = Loadable(
  lazy(() =>
    import("./NotificationsRulesList").then(({ NotificationsRulesList }) => ({
      default: NotificationsRulesList,
    }))
  )
);

export const notificationsRoutes = [
  {
    path: `/notifications-rules`,
    exact: true,
    element: (
      <AuthorizedRoute  allowFullAccess moduleKeys={[]}>
        <NotificationsRulesList />
      </AuthorizedRoute>
    ),
  },
]